import React, { useEffect, useState } from "react";
import Select from "react-select";

interface Option {
  value: string;
  label: string;
}

interface ColumnSelectorProps {
  options: Option[]; // Array of dropdown options
  onSelect: (option: Option | null) => void; // Callback for selection
  baseValue: Option | null;
}

const ColumnSelector: React.FC<ColumnSelectorProps> = ({ options, onSelect, baseValue }) => {
  const [selectedValue, setSelectedValue] = useState<Option | null>(null);

  // Update selected value when options or baseValue changes
  useEffect(() => {
    if (baseValue && options.length > 0) {
      // Find the matching option in the available options
      const matchingOption = options.find(
        (option) => option.value === baseValue.value
      );
      
      // Only set the value if we found a match
      if (matchingOption) {
        setSelectedValue(matchingOption);
      }
    }
  }, [options, baseValue]);

  return (
    <Select
      options={options}
      onChange={(newValue) => {
        setSelectedValue(newValue);
        onSelect(newValue);
      }}
      value={selectedValue}
      placeholder="Search for an attribute…"
      className="searchable-selector"
      menuPortalTarget={document.body} // Ensures menu renders at document body level
      menuPosition={'fixed'} // Fixed positioning
      menuPlacement={'auto'} // Automatically determine placement
      styles={{
        // Add custom styles to ensure menu appears above other content
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999 // Very high z-index
        })
      }}
    />
  );
};

export default ColumnSelector;